import { Button } from "@/components/Buttons";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback } from "react";
import IconComplete from "../../../svgs/icon_complete.svg";

export default function CompleteInquiry() {
  const router = useRouter();

  const handleClick = useCallback(() => {
    router.push(routes.home);
  }, []);

  return (
    <>
      <div className={`${processStyles.header} ${processStyles.cancelMb}`}>
        <div className={processStyles.icon}>
          <IconComplete />
        </div>
        <h4 className={processStyles.heading}>お問い合わせを送信しました</h4>
      </div>
      <Button fillColor large fontFixed onClick={handleClick}>
        トップへ戻る
      </Button>
    </>
  );
}
